export default {
    category: '*',
};
